import { Radiobox as RadioboxBase, Radio as RadioBase } from '@yandex-lego/components/Radiobox/desktop/bundle';

import './LegoRadiobox.scss';

export const Radiobox = RadioboxBase;
export const Radio = RadioBase;
